export default __webpack_public_path__ + "static/media/elements-filled-lime.e88837f2.svg";